/* eslint-disable consistent-return */
import { apiPaths, getApiPath, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

export const UPDATE_FLOW_END_SUCCESS = 'UPDATE_FLOW_END_SUCCESS'
export const UPDATE_FLOW_END_FAILURE = 'UPDATE_FLOW_END_FAILURE'
// ____________________________________________________________

/**
 * Update the values of a flowEnd broadcast two types of events:
 * - UPDATE_FLOW_END_SUCCESS: in case of success
 * - UPDATE_FLOW_END_FAILURE: in case of failure.
 *
 * @param {number} pid Project Id UUID
 * @param {number} sid Scenario Id UUID
 * @param {number} fid FlowGroup Id UUID
 * @param {object} flowEnd Flow condition to update
 * @returns {Promise<object>}
 */
export const updateFlowEnd = (pid, sid, fid, flowEnd) => async (dispatch) => {
  if (!flowEnd) {
    return
  }

  const path = getApiPath(apiPaths.FLOW_END_UPDATE, { pid, sid, fid })
  const api = new Api(path)
  const result = await api.update(flowEnd)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] flowEndsActions.updateFlowEnd()', { path, result, flowEnd })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_FLOW_END_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_FLOW_END_FAILURE,
    data: result.data
  })
}
